import React, { useCallback, useMemo } from 'react'

import { PaymentMethodStatus } from '@enums'
import { ConfirmPaymentParams, AlipayPaymentResponse } from '@hooks/useBookingFlow'
import { PaymentMethod } from '@pages/Checkout/hooks/Payment/useBookingPayment'
import PaymentLabel from '@pages/Checkout/Payment/Label'

const useDana = (): PaymentMethod => {
  const confirmPayment = useCallback((response: ConfirmPaymentParams) => {
    const { action, details } = response as AlipayPaymentResponse
    if (action === 'dana' && details.action.redirect?.redirectUrl != null) {
      window.location.href = details.action.redirect?.redirectUrl
    }
  }, [])

  return useMemo(
    () => ({
      status: PaymentMethodStatus.Ready,
      getOption: () => ({ value: 'dana', label: <PaymentLabel type="dana" /> }),
      provider: 'alipay',
      on: {
        submitForm: () => ({ paymentMethodData: { paymentMethodType: 'DANA' } }),
        confirmPayment,
      },
    }),
    [confirmPayment],
  )
}

export default useDana
